import type { BoxProps } from "@/ui/atoms/Box";
import Box from "@/ui/atoms/Box";
import React from "react";

import logoBlue from "./Proda_logo_blue.svg";
import type { TUserDatabase, TDealPropertyInfo } from "@/apis/odin/apiODIN";
import { isProductionEnvironment } from "@/utils/getEnvironment";
import { getProdaBaseUrl } from "@/utils/getProdaBaseUrl";

export type TopBarProps = BoxProps & {
    logoHref?: string;
    onLogoClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
    slotBanner?: React.ReactNode;
    selectedDatabases?: TUserDatabase[];
    currentDeal?: TDealPropertyInfo;
};

const TopBar = (props: TopBarProps) => {
    const {
        children,
        logoHref = "/",
        onLogoClick,
        slotBanner,
        ...otherProps
    } = props;

    const handleLogoClick = React.useCallback(
        (event: React.MouseEvent<HTMLAnchorElement>) => {
            event.preventDefault();

            if (!isProductionEnvironment()) {
                window.location.assign(getProdaBaseUrl());
                return;
            }

            onLogoClick?.(event);
        },
        [onLogoClick],
    );

    return (
        <Box
            className="top-bar"
            sx={{
                display: "flex",
                flexDirection: "column",
            }}
            {...otherProps}
        >
            {slotBanner}
            <Box
                id="top-bar"
                sx={{
                    display: "flex",
                    alignItems: "center",
                    borderBottom: "1px solid var(--proda-black)",
                    justifyContent: "space-between",
                    backgroundColor: "var(--proda-white-110)",
                    height: "60px",
                    paddingLeft: "calc(0.625rem + 5px)",
                    paddingRight: "40px",
                    border: "none",
                }}
            >
                <Box>
                    <Box
                        component={"a"}
                        href={logoHref}
                        onClick={handleLogoClick}
                        id="logo-container"
                        sx={{
                            height: "39px",
                        }}
                    >
                        <Box
                            component={"img"}
                            src={logoBlue}
                            alt="Logo"
                            marginTop="6px"
                            width="140px"
                            id="proda-logo"
                        />
                    </Box>
                </Box>
                <Box
                    sx={{
                        flexGrow: 1,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        flexDirection: "row",
                        gap: "12px",
                    }}
                >
                    {children}
                </Box>
            </Box>
        </Box>
    );
};

export default TopBar;
